import { Station } from "features/predictionMap/api/getStations";

export type variableType = "precipitation" | "floodForecast" | "waterLevel"

export type AlertConditionType = {
  variable: variableType;
  timerange: Number;
  threshold: Number;
  notification: string;
};

export const initialAlertCondition: AlertConditionType = {
  variable: 'floodForecast',
  timerange: 0,
  threshold: 10,
  notification: 'mail',
};

export type alertObjType = {
  name: string;
  address: string;
  conditions?: AlertConditionType[];
  id: string;
  is_area: boolean
  latitude: number;
  longitude: number;
  latitude_nw?: number;
  longitude_nw?: number;
  latitude_se?: number;
  longitude_se?: number;
  station: Station | null;
};

export type alertResponseType = {
  name: string;
  address: string;
  id: string;
};

export type addAlertRequestType = {
  name: string;
  latitude: number;
  longitude: number;
  address?: string;
  latitude_nw?: number;
  longitude_nw?: number;
  latitude_se?: number;
  longitude_se?: number;
  station?: number;
};

export type alertListType = alertObjType[];

export type areaCoordinateType = {
  topLeftLon: number,
  topLeftLat: number,
  bottomRightLon: number,
  bottomRightLat: number,
}

export type areaCoordinateKeyType = keyof areaCoordinateType

export type otherSettingsType = {
  shareWithClient: boolean;
}

export type locationMarkerType = {
  lat: number;
  lon: number;
}

export type LocationRegisterMapProps = {
  currentMarker: locationMarkerType;
  onChange: (location: { latitude: number; longitude: number }) => void;
}